import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1a9bb128&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {NavItems: require('/lasso/components/NavItems.vue').default,Template: require('/lasso/components/templates/Template.vue').default,Header: require('/lasso/components/Header.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a9bb128')) {
      api.createRecord('1a9bb128', component.options)
    } else {
      api.reload('1a9bb128', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=1a9bb128&", function () {
      api.rerender('1a9bb128', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Header.vue"
export default component.exports